import { map, pick } from 'lodash';
import { v1 as uuid } from 'uuid';

export const getTransformedData = (data = {}) => {
  const { hasQuotas, values } = data;

  const cleanValues = map(values, (value) =>
    pick(value, [
      'value',
      'label',
      'relations',
      'quotaCompletes',
      'id',
      'refId',
    ]),
  );

  return { values: cleanValues, hasQuotas };
};

export const getFullLabel = ({ label, relations }, delimiter = ', ') =>
  [label, ...map(relations, ({ label: relationLabel }) => relationLabel)].join(
    delimiter,
  );

export const defaultCountries = () => [
  {
    refId: uuid(),
    value: 'us',
    label: 'United States',
    relations: [],
  },
];
